import React from 'react';

import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import {Modal, Button, DatePicker, Table, message, Divider, Dropdown, Menu} from 'antd';

import {Row, Col, Select, Checkbox, Spin, Tooltip as Toltip, Popover} from 'antd';
import {Icon} from 'antd';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import './adminDashboard.scss';
import CloudFlyerAPI from "../../api/CloudFlyerAPI";
import {receiveError} from "../../api/http";
import prettysize from "../../utils";
import moment from "moment";
import infoIcon from "../../assets/svg/info_icon.svg";


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Data is shown in TB',
        },
        interaction: {
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    },
};


/*const text = <span>Title</span>;*/


const {RangePicker} = DatePicker;
const dateFormat = 'YYYY/MM/DD';

const {Option} = Select;

class AdminDashbord extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dashboard_report_data: "",
            dashboardChartDate: [],
            pageChartDate: null,
            startDate: moment().subtract(12, "months"),
            endDate: moment(),
            transferHistory: [],
            chartData: {
                labels: [],
                datasets: []
            },
            pageSize: 10,
            page: 1,
            total: 0,
        }
        this.refreshOngoingTransfer = this.refreshOngoingTransfer.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: true,
        })
        const {match} = this.props
        let user = JSON.parse(localStorage.getItem('user')) || {
            bypass_onboard: true,
        }
        this.setState({
            dashboardChartDate: []
        });
        CloudFlyerAPI.report_admin
            .getDashboardReport(this.state.pageSize, this.state.page)
            .then(({data}) => {
                this.setState({
                    loading: false,
                    dashboard_report_data: data
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
        this.dashboardChartRender();
        this.getTransferHistory()
    }

    convertToTB(b) {
        return (b / (1024 * 1024 * 1024 * 1024)).toFixed(2);
    }

    onPeriodChange = (value) => {
        let startDate = value[0]
        let endDate = value[1]
        this.setState(
            {
                loading: true,
                startDate: startDate,
                endDate: endDate
            })
        this.dashboardChartRender();
    }
    dashboardChartRender = () => {
        CloudFlyerAPI.report_admin
            .postDashboardChartDate(this.state.startDate.format('YYYY-MM-DD'), this.state.endDate.format('YYYY-MM-DD'))
            .then(({data}) => {
                var monthName = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                var chart = {
                    labels: [],
                    datasets: [
                        {
                            label: "Wasabi Transfers ",
                            fill: false,
                            backgroundColor: "rgba(6,31,50,0.8)",
                            borderColor: "rgba(6,31,50,1)",
                            data: [],
                            stack: 'Stack 0'
                        },
                        {
                            label: "Out of wasabi Transfers ",
                            fill: false,
                            backgroundColor: "rgba(6,31,50,0.5)",
                            borderColor: "rgba(6,31,50,1)",
                            data: [],
                            stack: 'Stack 0'
                        },
                        {
                            label: "Traffic for Replication Seed Data",
                            fill: false,
                            backgroundColor: "rgba(40,215,174,0.8)",
                            borderColor: "rgb(40,215,174)",
                            data: [], // these are empty arrays
                            stack: 'Stack 1'
                        },
                        {
                            label: "Traffic for Replication Sync",
                            fill: false,
                            backgroundColor: "rgba(15,108,12,0.8)",
                            borderColor: "rgb(15,108,12)",
                            data: [], // these are empty arrays
                            stack: 'Stack 1'
                        },
                        {
                            label: "Traffic for Migration AWS",
                            fill: false,
                            backgroundColor: "rgba(255,153,0,0.8)",
                            borderColor: "rgba(255,153,0,1)",
                            data: [],
                            stack: 'Stack 2'
                        },
                        {
                            label: "Traffic for Migration Wasabi",
                            fill: false,
                            backgroundColor: "rgba(80,184,77,0.8)",
                            borderColor: "rgba(80,184,77,1)",
                            data: [],
                            stack: 'Stack 1'
                        },
                        {
                            label: "Traffic for Migration Azure",
                            fill: false,
                            backgroundColor: "rgba(0,133,207,0.8)",
                            borderColor: "rgba(0,133,207,1)",
                            data: [],
                            stack: 'Stack 2'
                        },
                        {
                            label: "Traffic for Migration S3 Generic",
                            fill: false,
                            backgroundColor: "rgba(224,82,67,0.8)",
                            borderColor: "rgba(224,82,67,1)",
                            data: [],
                            stack: 'Stack 2'
                        },
                        {
                            label: "Traffic for Migration Google",
                            fill: false,
                            backgroundColor: "rgba(218,214,21,0.8)",
                            borderColor: "rgb(218,214,21)",
                            data: [],
                            stack: 'Stack 2'
                        }
                    ]
                }

                /*
  {
    "transferSize": 14190573418476,
    "syncSize": 338911514920777,
    "transferDetail": {
      "aws": 14055251371537,
      "wasabi": 135322046939,
      "azure": 0,
      "s3Generic": 0,
      "google": 0
    },
    "syncDetail": {
      "seedData": 0,
      "sync": 338911514920777
    },
    "fromDate": "2022-09-01T00:00:00",
    "toDate": "2022-10-01T00:00:00",
    "totalSize": 353102088339253
  },*/

                for (var i = 0; i < data.length; i++) {
                    var month = monthName[new Date(data[i].fromDate).getMonth()];
                    //setting data to aary here
                    //is that ok? can you call me, here data push to data[] then what I can do
                    chart.labels.push(month);
                    var totalWasabi = (data[i].syncDetail.seedData + data[i].syncDetail.sync + data[i].transferDetail.wasabi);

                    chart.datasets[0].data.push(this.convertToTB(totalWasabi));
                    chart.datasets[1].data.push(this.convertToTB((data[i].totalSize - totalWasabi)));

                    chart.datasets[2].data.push(this.convertToTB(data[i].syncDetail.seedData));
                    chart.datasets[3].data.push(this.convertToTB(data[i].syncDetail.sync));
                    chart.datasets[4].data.push(this.convertToTB(data[i].transferDetail.aws));
                    chart.datasets[5].data.push(this.convertToTB(data[i].transferDetail.wasabi));
                    chart.datasets[6].data.push(this.convertToTB(data[i].transferDetail.azure));
                    chart.datasets[7].data.push(this.convertToTB(data[i].transferDetail.s3Generic));
                    chart.datasets[8].data.push(this.convertToTB(data[i].transferDetail.google));
                }
                this.setState({chartData: {}});
                this.setState({
                    loading: false,
                    chartData: chart
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    }
    refreshOngoingTransfer = () => {
        this.setState({
            loading: true,
        })
        this.getTransferHistory()
    }

    getTransferHistory() {
        let filters = {
            transferType: 0,
            transferStatus: 130,
            sources: [],
        };

        CloudFlyerAPI.user_account
            .getTransferHistory(filters, this.state.pageSize, this.state.page)
            .then(({data}) => {
                this.setState({
                    transferHistory: data.data,
                    loading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                    historyLoading: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    }

    onPageChange = (page) => {
        this.setState({page: page, loading: true}, () => {
            this.getTransferHistory()
        });
    };

    cancelTransfer(id) {
        let req = {
            id: id
        };
        CloudFlyerAPI.report_admin
            .cancelTransfer(req)
            .then(({data}) => {
                this.getTransferHistory()
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    };

    pauseTransfer(id) {
        let req = {
            id: id
        };
        CloudFlyerAPI.report_admin
            .pauseTransfer(req)
            .then(({data}) => {
                this.getTransferHistory()
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    };

    resumeTransfer(id) {
        let req = {
            id: id
        };
        CloudFlyerAPI.report_admin
            .resumeTransfer(req)
            .then(({data}) => {
                this.getTransferHistory()
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    };

    transferTooltip(data, t) {
        return (<div className="table-tooltip">{data} <Toltip placement="left" title={(<div>Total Transfer Size: {prettysize(t.totalSize)}<br/>
            Total Objects: {t.total}<br/>
            Transferred Size: {prettysize(t.transferredSize)}<br/>
            Transferred: {t.transferred} <br/>
            Skipped: {t.skipped}<br/>
            Failed: {t.failed}<br/>
            Deleted: {t.deleted}
        </div>)}><img src={infoIcon} alt="info"/></Toltip></div>);
    }

    ongoingMenu(status, id) {
        if (status === "Ongoing") {
            let menu = (
                <Menu className="ongoing-menu-item">
                    <Menu.Item key="0">
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            this.cancelTransfer(id)
                        }}>Cancel</a>
                    </Menu.Item>
                    <Menu.Item key="1">
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            this.pauseTransfer(id)
                        }}>Pause</a>
                    </Menu.Item>
                </Menu>
            );
            return (<div className="custom-menu">Ongoing
                <Dropdown overlay={menu} trigger={['click']}>
                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                        ...
                    </a>
                </Dropdown>
            </div>);
        } else if (status === "Paused") {
            let menu = (
                <Menu className="ongoing-menu-item">
                    <Menu.Item key="0">
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            this.cancelTransfer(id)
                        }}>Cancel</a>
                    </Menu.Item>
                    <Menu.Item key="1">
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            this.resumeTransfer(id)
                        }}>Resume</a>
                    </Menu.Item>
                </Menu>
            );
            return (<div className="custom-menu">Paused
                <Dropdown overlay={menu} trigger={['click']}>
                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                        ...
                    </a>
                </Dropdown>
            </div>);
        } else {
            return status;
        }
    }

    render() {


        let transferStatuses = new Map();
        transferStatuses.set(0, "All");
        transferStatuses.set(2, "Ongoing");
        transferStatuses.set(4, "Completed");
        transferStatuses.set(128, "Paused");
        transferStatuses.set(8, "Cancelled");
        transferStatuses.set(16, "Failed");

        let directions = new Map();
        directions.set(1, "AWS to Wasabi");
        directions.set(2, "Wasabi to Wasabi");
        directions.set(4, "Azure to Wasabi");
        directions.set(8, "S3 Generic to Wasabi");
        directions.set(16, "Google to Wasabi");

        let transferTypes = new Map();
        transferTypes.set(0, "All");
        transferTypes.set(1, "Migration");
        transferTypes.set(2, "Replication");
        transferTypes.set(4, "Seed Data Replication");
        transferTypes.set(8, "Manual Transfer");

        const {providers} = this.state
        const {match} = this.props
        const {user, history} = this.props

        const columns = [
            {
                title: "User",
                dataIndex: "username",
                key: "username",
                ellipsis: {
                    showTitle: false,
                },
                render: (username) => (
                    <Toltip placement="topLeft" title={username}>
                        {username}
                    </Toltip>
                ),
                width: 150,
            },
            {
                title: "Account",
                dataIndex: "accountName",
                key: "accountName",
                ellipsis: {
                    showTitle: false,
                },
                render: (accountName) => (
                    <Toltip placement="topLeft" title={accountName}>
                        {accountName}
                    </Toltip>
                ),
                width: 150,
            },
            {
                title: "Direction",
                dataIndex: "direction",
                key: "direction",
                width: 130,
            },
            {
                title: "Source Bucket",
                dataIndex: "source",
                key: "source",
                ellipsis: {
                    showTitle: false,
                },
                render: (source) => (
                    <Toltip placement="topLeft" title={source}>
                        {source}
                    </Toltip>
                ),
                width: 130,
            },
            {
                title: "Source Region",
                dataIndex: "sourceRegion",
                key: "sourceRegion",
                width: 120,
            },
            {
                title: "Destination Bucket",
                dataIndex: "destination",
                key: "destination",
                ellipsis: {
                    showTitle: false,
                },
                render: (destination) => (
                    <Toltip placement="topLeft" title={destination}>
                        {destination}
                    </Toltip>
                ),
                width: 130,
            },
            {
                title: "Destination Region",
                dataIndex: "destinationRegion",
                key: "destinationRegion",
                width: 120,
            },
            {
                title: "Date",
                dataIndex: "date",
                key: "date",
                width: 150,
            },
            {
                title: "Transfer Status",
                dataIndex: "transferStatus",
                key: "transferStatus",
                width: 120,
            },
            {
                title: "Transfer Type",
                dataIndex: "transferType",
                key: "transferType",
                width: 150,
            },
        ];

        let tableData = this.state?.transferHistory?.map((t, index) => {
            return {
                key: t.id,
                username: t.username,
                accountName: t.accountName,
                direction: directions.get(t.source),
                source: t.sourceBucket,
                sourceRegion: t.sourceRegion,
                destination: t.destinationBucket,
                destinationRegion: t.destinationRegion,
                date: moment
                    .parseZone(t.requestDate)
                    .local()
                    .format("MM/DD/YYYY HH:mm:ss"),
                transferStatus: this.ongoingMenu(transferStatuses.get(t.transferStatus), t.id),
                transferType: this.transferTooltip(transferTypes.get(t.transferType), t),
            }
        })
        return (
            <div className="adminDashboard">
                <div className="header">
                    <div className="left-wrapper">
                        <h2>Admin Dashboard</h2>
                    </div>
                    <div className="right-wrapper">
                    </div>
                </div>
                <div className="content">
                    <Spin spinning={this.state.loading}>
                        <Row gutter={30} type="flex">
                            <Col className="gutter-row" lg={12} xl={6} span={24}>
                                <div className="details-card red">
                                    <div className="icon">
                                        <Icon type="idcard"/>
                                    </div>
                                    <div className="content">
                                        <span>{this.state.dashboard_report_data.totalAccounts} / {this.state.dashboard_report_data.activeAccounts}</span>
                                        <strong>Total Accounts / Active Accounts</strong>
                                    </div>
                                </div>
                            </Col>
                            <Col className="gutter-row" lg={12} xl={6} span={24}>
                                <div className="details-card sky-blue">
                                    <div className="icon">
                                        <Icon type="user"/>
                                    </div>
                                    <div className="content">
                                        <span>{this.state.dashboard_report_data.totalUsers}</span>
                                        <strong>Total Users</strong>
                                    </div>
                                </div>
                            </Col>
                            <Col className="gutter-row" lg={12} xl={6} span={24}>
                                <div className="details-card green">
                                    <div className="icon">
                                        <Icon type="smile" theme="filled"/>
                                    </div>
                                    <div className="content">
                                        <span>{this.state.dashboard_report_data.activeUsers}</span>
                                        <strong>Active Users</strong>
                                    </div>
                                </div>
                            </Col>
                            <Col className="gutter-row" lg={12} xl={6} span={24}>
                                <div className="details-card blue">
                                    <div className="icon">
                                        <Icon type="book"/>
                                    </div>
                                    <div className="content">
                                        <span>{this.state.dashboard_report_data.totalReplications} / {this.state.dashboard_report_data.activeReplications}</span>
                                        <strong>Total Replications / Active Replications</strong>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Spin>
                    <div className="charts">
                        <div className="period-wrapper">
                            <div className="period-content">
                                <div className="start-date">
                                    <h4>Start Date ~ End Date</h4>
                                    <RangePicker
                                        width={400}
                                        onChange={value => this.onPeriodChange(value)}
                                        defaultValue={[this.state.startDate, this.state.endDate]}
                                        format={dateFormat}
                                    />
                                </div>
                            </div>
                        </div>
                        <Spin spinning={this.state.loading}>
                            <Bar options={options} data={this.state.chartData}/>
                        </Spin>
                    </div>


                    <div className="active-jobs-wrapper-list">
                        <Spin spinning={this.state.loading}>
                            <Button icon='sync' shape="circle" className={'refresh-list'} size={'small'} onClick={this.refreshOngoingTransfer}/>
                            <Table
                                loading={this.state.loading}
                                columns={columns}
                                dataSource={tableData}
                                pagination={{
                                    onChange: this.onPageChange,
                                    total: this.state.total,
                                    current: this.state.page,
                                    showTotal: (total, range) =>
                                        `${range[0]}-${range[1]} of ${total} items`,
                                    pageSize: this.state.pageSize,
                                }}
                                scroll={{y: 600}}
                            />
                        </Spin>
                    </div>
                </div>
                {/* <div className="usage-cost-wrapper">
                    <ServiceUsage/>
                    <TransferReport/>
                </div>
                <div className="active-jobs-wrapper">
                    <ActiveJobsList/>
                </div> */}
            </div>

        )
    }
}

export default withRouter(
    connect(
        ({auth, cloudAccounts}, {match, history}) => {
            let user = auth.user
            return {
                ...user,
                cloudAccounts,
            }
        },
        dispatch => bindActionCreators({}, dispatch)
    )(AdminDashbord)
)
